import { render, staticRenderFns } from "./referenciasPersonales.vue?vue&type=template&id=89c43d0e"
import script from "./referenciasPersonales.vue?vue&type=script&lang=js"
export * from "./referenciasPersonales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports